import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import * as env from "shared/env";

export const styles = (theme: Theme) => {
	return ({
		cardContainer: {
			width: "100%"
		},
		cardHeaderRoot: {
			...{ alignItems: "flex-start" },
		},
		cardHeaderTitle: {
			...{ marginBottom: 12 },
		},
		image: {
			height: 200,
		},
		truncatedMessage: {
			display: "inline-block", 
			maxWidth: 500, 
			overflow: "hidden", 
			textOverflow: "ellipsis", 
			whiteSpace: "nowrap", 
			verticalAlign: "top", 
			WebkitLineClamp: 1
		},
		textResponded: {
			paddingBottom: 20,
		},
		card: {
			overflowWrap: "anywhere",
		},
	} satisfies Record<string, CSSObject>);
};
